export function Hero() {
  return (
    <section className="max-w-6xl mx-auto px-6 py-16 flex flex-col md:flex-row items-center md:space-x-12 space-y-8 md:space-y-0">
      <div className="flex-1">
        <span className="text-sm uppercase tracking-wider bg-gray-200 px-2 py-1 rounded-full text-gray-700">
          Ethos Tech Hub Limited
        </span>
        <h1 className="text-4xl md:text-5xl font-extrabold mt-4">
          Ethos | Smart Production
        </h1>
        <p className="mt-4 text-gray-600 text-lg">
          Transform your manufacturing floor with our intelligent mobile and tablet solution 
          that automates the entire production lifecycle. From real-time operator activities 
          and machine performance monitoring to quality control checks and seamless ERP integration — 
          Ethos Smart Production brings complete visibility and efficiency to your manufacturing operations.
        </p>
        
      </div>
      <div className="flex-1">
        <img
          src="/images/production/production.png" 
          alt="Smart Production Mobile App Dashboard"
          className="w-64 mx-auto shadow-lg rounded-lg"
        />
      </div>
    </section>
  );
}